import React from 'react';
import { ReactComponent as FlaggedIcon } from './../../../resources/flagged.svg';
import { ReactComponent as NotFlaggedIcon } from './../../../resources/not_flagged.svg';
import styled from 'styled-components';

const FlaggedOrder = ({ flagged }) => {
  return (
    <FlagIconWrapper>
      {flagged ? <FlaggedIcon /> : <NotFlaggedIcon />}
    </FlagIconWrapper>
  );
};

const FlagIconWrapper = styled.div`
  padding: 15px;
`;

export default FlaggedOrder;
